import styled from "styled-components";
import { textTheme, colorTheme } from "../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 35px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 1108px;
  margin-top: 25px;
`;

export const Header = styled.div<{ isExec: boolean }>`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: ${props => (props.isExec ? "" : "40px")};
`;

export const Title = styled.div`
  ${textTheme.h3};
  margin-bottom: 10px;
  color: ${colorTheme.black};
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const Tab = styled.button<{ onClick: any; isSelected: boolean }>`
  border: none;
  padding: 0px;
  background-color: white;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.1px;
  color: ${props => (props.isSelected ? "#373f41;" : "#C3CBCD;")};
  &:hover {
    cursor: pointer;
  }
`;

export const TileContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
`;

export const ChartContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

export const TableContainer = styled.div`
  position: relative;
  margin-top: 35px;
`;

export const TableTitle = styled.div`
  position: absolute;
  z-index: 11;
  top: 10px;
  ${textTheme.h6}
  color: ${colorTheme.black};
`;

export const TableContent = styled.div`
  margin-top: 7px;
`;

export const Spinner = styled.div`
  height: 279px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
